<button class="fe-menu-item" (click)="onClick.emit()"
        [ngClass]="{'fe-menu-item-default' : color === 'DEFAULT','fe-menu-item-blue' : color === 'PRIMARY',
        'fe-menu-item-danger' : color === 'DANGER'}" mat-menu-item>
    <div class="first-line">
        <fe-icon *ngIf="icon" class="fe-menu-item-icon" [iconType]="icon" [color]="iconColor"/>
        <span [class.bold]="bold" [innerHTML]="text"></span>
    </div>
    <span class="description">{{description}}</span>
</button>
